module.exports = __webpack_public_path__ + "static/img/s_photofacial.eeb3833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/s_photofacial.jpg
// module id = 104
// module chunks = 1